import * as React from 'react';

import {motion} from 'framer-motion';

import {AccountsCircleIcon} from 'shells/icon/svg/accounts-circle-icon';
import {ContactsCircleIcon} from 'shells/icon/svg/contacts-circle-icon';
import type {PageChangeDirection} from 'shells/onboarding-modal/types';
import {Title} from 'shells/typography/title';

import {GrowingDottedLine} from '../graphics-pieces/growing-dotted-line';

import styles from './graphic-people-companies.module.css';

type Props = {
    direction: PageChangeDirection;
};

export class GraphicPeopleCompanies extends React.PureComponent<Props> {
    render() {
        const shouldAnimate = this.props.direction === 'forward';

        return (
            <div className={styles['graphic-container']}>
                <div className={styles.graphic}>
                    <div className={styles.entity}>
                        <div className={styles['icon-background']}>
                            {/* @ts-expect-error */}
                            <ContactsCircleIcon size='100%' fill='#fff' wrapWithDiv={false} />
                        </div>
                        <Title>Sara Diaz</Title>
                        <div className={styles.subtitle}>Person</div>
                    </div>
                    <GrowingDottedLine preventAnimation={!shouldAnimate} />
                    <div className={styles.entity}>
                        <motion.div
                            style={{opacity: 0}}
                            animate={{opacity: 1}}
                            transition={{delay: 0.5}}
                            initial={shouldAnimate && undefined}
                            className={styles.entity}
                        >
                            <div className={styles['icon-background']}>
                                {/* @ts-expect-error */}
                                <AccountsCircleIcon size='100%' fill='#fff' wrapWithDiv={false} />
                            </div>
                            <Title>ArrowGrid</Title>
                            <div className={styles.subtitle}>Company</div>
                        </motion.div>
                    </div>
                </div>
            </div>
        );
    }
}
